(() => {
  window.addEventListener('message', (e) => {
    if (!e.data || !e.data.action || !e.data.data || e.data.action !== 'resize') {
      return;
    }

    const iframe = window.swinger.$('.swinger-iframe__iframe')
      .filter((elem) => elem.name === e.data.data.name)[0];

    if (iframe) {
      iframe.setAttribute('height', e.data.data.height);
    }
  });
})();
